import { MessageCircle } from "lucide-react";

export function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-16 border-t border-[#2A2A30]/60 bg-[#0A0A0B]/70"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="text-[10px] uppercase tracking-[0.25em] text-[#6E6A5E] font-bold">
          PodziemieTFT · Turniej · Set 17
        </div>
        <div className="text-xs text-[#A09B8C] flex items-center gap-1.5">
          <span>Strona stworzona przez</span>
          <span className="inline-flex items-center gap-1 font-bold text-[#C8AA6E]">
            <MessageCircle className="h-3.5 w-3.5" />
            xNoternus
          </span>
          <span className="text-[#6E6A5E]">(discord)</span>
        </div>
      </div>
    </footer>
  );
}
